import React, { Component } from "react";
import { Input } from "reactstrap";

class StateList extends Component {
  // constructor(props)
  // {
  //     super(props);
  // }
  render() {
    console.log("this.props.stateFillData", this.props.stateFillData);
    return (
      <Input type="select" name="drpState" id="drpState" value={this.props.stateValue} onChange={this.props.drpChangeState}>
        <option value="">--Select State--</option>
        {this.props.stateFillData.map((item, i) => (
          <option key={item.state_id} value={item.state_id}>
            {item.state_name}
          </option>
        ))}
      </Input>
    );
  }
}
StateList.defaultProps = {
  stateFillData: [],
  stateValue: "",
};

export default StateList;



// WEBPACK FOOTER //
// ./src/shared/components/state_list/index.js